// Villes ayant leur propre page SEO complète sous l'URL plate
// `/carton-demenagement-:slug` (département Yvelines / 78).
// Convention SEO différente du 92 (test A/B keyword-rich URLs).

const YVELINES_CITY_PAGES = [
  {
    slug: "versailles",
    name: "Versailles",
    aCity: "à Versailles",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "versailles",
    isPhare: true,
    nearbyCities: [
      "Le Chesnay-Rocquencourt",
      "Vélizy-Villacoublay",
      "Saint-Cyr-l'École",
      "Viroflay",
      "Buc",
      "Guyancourt",
      "Montigny-le-Bretonneux",
    ],
  },
  {
    slug: "le-chesnay-rocquencourt",
    name: "Le Chesnay-Rocquencourt",
    aCity: "au Chesnay-Rocquencourt",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "le-chesnay-rocquencourt",
    isPhare: false,
    parentPhareSlug: "versailles",
    nearbyCities: [
      "Versailles",
      "Bailly",
      "La Celle-Saint-Cloud",
      "Louveciennes",
      "Bougival",
    ],
  },
  {
    slug: "velizy-villacoublay",
    name: "Vélizy-Villacoublay",
    aCity: "à Vélizy-Villacoublay",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "velizy-villacoublay",
    isPhare: false,
    parentPhareSlug: "versailles",
    nearbyCities: [
      "Versailles",
      "Meudon",
      "Clamart",
      "Jouy-en-Josas",
      "Bièvres",
    ],
  },
  {
    slug: "saint-cyr-lecole",
    name: "Saint-Cyr-l'École",
    aCity: "à Saint-Cyr-l'École",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "saint-cyr-lecole",
    isPhare: false,
    parentPhareSlug: "versailles",
    nearbyCities: [
      "Versailles",
      "Fontenay-le-Fleury",
      "Guyancourt",
      "Bois-d'Arcy",
      "Montigny-le-Bretonneux",
    ],
  },
  {
    slug: "viroflay",
    name: "Viroflay",
    aCity: "à Viroflay",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "viroflay",
    isPhare: false,
    parentPhareSlug: "versailles",
    nearbyCities: [
      "Versailles",
      "Chaville",
      "Vélizy-Villacoublay",
      "Meudon",
      "Sèvres",
    ],
  },
  {
    slug: "buc",
    name: "Buc",
    aCity: "à Buc",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "buc",
    isPhare: false,
    parentPhareSlug: "versailles",
    nearbyCities: [
      "Versailles",
      "Guyancourt",
      "Les Loges-en-Josas",
      "Jouy-en-Josas",
    ],
  },
  {
    slug: "guyancourt",
    name: "Guyancourt",
    aCity: "à Guyancourt",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "guyancourt",
    isPhare: false,
    parentPhareSlug: "versailles",
    nearbyCities: [
      "Versailles",
      "Voisins-le-Bretonneux",
      "Montigny-le-Bretonneux",
      "Buc",
    ],
  },
  {
    slug: "montigny-le-bretonneux",
    name: "Montigny-le-Bretonneux",
    aCity: "à Montigny-le-Bretonneux",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "montigny-le-bretonneux",
    isPhare: false,
    parentPhareSlug: "versailles",
    nearbyCities: [
      "Versailles",
      "Voisins-le-Bretonneux",
      "Guyancourt",
      "Trappes",
      "Élancourt",
      "Bois-d'Arcy",
    ],
  },
  {
    slug: "trappes",
    name: "Trappes",
    aCity: "à Trappes",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "trappes",
    isPhare: true,
    parentPhareSlug: null,
    nearbyCities: [
      "Châteaufort",
      "Bois-d'Arcy",
      "Fontenay-le-Fleury",
      "Les Clayes-sous-Bois",
      "Jouy-en-Josas",
      "Les Loges-en-Josas",
      "Toussus-le-Noble",
    ],
  },
  {
    slug: "chateaufort",
    name: "Châteaufort",
    aCity: "à Châteaufort",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "chateaufort",
    isPhare: false,
    parentPhareSlug: "trappes",
    nearbyCities: [
      "Trappes",
      "Magny-les-Hameaux",
      "Toussus-le-Noble",
      "Buc",
      "Guyancourt",
    ],
  },
  {
    slug: "bois-darcy",
    name: "Bois-d'Arcy",
    aCity: "à Bois-d'Arcy",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "bois-darcy",
    isPhare: false,
    parentPhareSlug: "trappes",
    nearbyCities: [
      "Trappes",
      "Saint-Cyr-l'École",
      "Fontenay-le-Fleury",
      "Villepreux",
      "Montigny-le-Bretonneux",
    ],
  },
  {
    slug: "fontenay-le-fleury",
    name: "Fontenay-le-Fleury",
    aCity: "à Fontenay-le-Fleury",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "fontenay-le-fleury",
    isPhare: false,
    parentPhareSlug: "trappes",
    nearbyCities: [
      "Trappes",
      "Saint-Cyr-l'École",
      "Bois-d'Arcy",
      "Villepreux",
      "Noisy-le-Roi",
    ],
  },
  {
    slug: "les-clayes-sous-bois",
    name: "Les Clayes-sous-Bois",
    aCity: "aux Clayes-sous-Bois",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "les-clayes-sous-bois",
    isPhare: false,
    parentPhareSlug: "trappes",
    nearbyCities: [
      "Trappes",
      "Plaisir",
      "Villepreux",
      "Bois-d'Arcy",
      "Fontenay-le-Fleury",
      "Saint-Cyr-l'École",
    ],
  },
  {
    slug: "jouy-en-josas",
    name: "Jouy-en-Josas",
    aCity: "à Jouy-en-Josas",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "jouy-en-josas",
    isPhare: false,
    parentPhareSlug: "trappes",
    nearbyCities: [
      "Trappes",
      "Buc",
      "Les Loges-en-Josas",
      "Vélizy-Villacoublay",
      "Versailles",
    ],
  },
  {
    slug: "les-loges-en-josas",
    name: "Les Loges-en-Josas",
    aCity: "aux Loges-en-Josas",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "les-loges-en-josas",
    isPhare: false,
    parentPhareSlug: "trappes",
    nearbyCities: [
      "Trappes",
      "Jouy-en-Josas",
      "Buc",
      "Toussus-le-Noble",
      "Vélizy-Villacoublay",
      "Versailles",
    ],
  },
  {
    slug: "toussus-le-noble",
    name: "Toussus-le-Noble",
    aCity: "à Toussus-le-Noble",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "toussus-le-noble",
    isPhare: false,
    parentPhareSlug: "trappes",
    nearbyCities: [
      "Trappes",
      "Buc",
      "Châteaufort",
      "Les Loges-en-Josas",
      "Guyancourt",
      "Villiers-le-Bâcle",
    ],
  },
  {
    slug: "plaisir",
    name: "Plaisir",
    aCity: "à Plaisir",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "plaisir",
    isPhare: true,
    parentPhareSlug: null,
    nearbyCities: [
      "Villepreux",
      "Chavenay",
      "Rennemoulin",
      "Noisy-le-Roi",
      "Bailly",
      "Saint-Nom-la-Bretèche",
      "Davron",
    ],
  },
  {
    slug: "villepreux",
    name: "Villepreux",
    aCity: "à Villepreux",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "villepreux",
    isPhare: false,
    parentPhareSlug: "plaisir",
    nearbyCities: [
      "Plaisir",
      "Les Clayes-sous-Bois",
      "Saint-Nom-la-Bretèche",
      "Chavenay",
      "Fontenay-le-Fleury",
      "Rennemoulin",
    ],
  },
  {
    slug: "chavenay",
    name: "Chavenay",
    aCity: "à Chavenay",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "chavenay",
    isPhare: false,
    parentPhareSlug: "plaisir",
    nearbyCities: [
      "Plaisir",
      "Villepreux",
      "Saint-Nom-la-Bretèche",
      "Les Clayes-sous-Bois",
      "Feucherolles",
    ],
  },
  {
    slug: "rennemoulin",
    name: "Rennemoulin",
    aCity: "à Rennemoulin",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "rennemoulin",
    isPhare: false,
    parentPhareSlug: "plaisir",
    nearbyCities: [
      "Plaisir",
      "Noisy-le-Roi",
      "Bailly",
      "Fontenay-le-Fleury",
      "Villepreux",
    ],
  },
  {
    slug: "noisy-le-roi",
    name: "Noisy-le-Roi",
    aCity: "à Noisy-le-Roi",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "noisy-le-roi",
    isPhare: false,
    parentPhareSlug: "plaisir",
    nearbyCities: [
      "Plaisir",
      "Bailly",
      "Saint-Nom-la-Bretèche",
      "Rennemoulin",
      "Fontenay-le-Fleury",
      "Villepreux",
    ],
  },
  {
    slug: "bailly",
    name: "Bailly",
    aCity: "à Bailly",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "bailly",
    isPhare: false,
    parentPhareSlug: "plaisir",
    nearbyCities: [
      "Plaisir",
      "Noisy-le-Roi",
      "Rocquencourt",
      "Versailles",
      "Louveciennes",
    ],
  },
  {
    slug: "saint-nom-la-breteche",
    name: "Saint-Nom-la-Bretèche",
    aCity: "à Saint-Nom-la-Bretèche",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "saint-nom-la-breteche",
    isPhare: false,
    parentPhareSlug: "plaisir",
    nearbyCities: [
      "Plaisir",
      "Noisy-le-Roi",
      "Bailly",
      "Feucherolles",
      "Chavenay",
      "Villepreux",
    ],
  },
  {
    slug: "davron",
    name: "Davron",
    aCity: "à Davron",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "davron",
    isPhare: false,
    parentPhareSlug: "plaisir",
    nearbyCities: [
      "Plaisir",
      "Crespières",
      "Feucherolles",
      "Thiverval-Grignon",
      "Chavenay",
    ],
  },
  {
    slug: "poissy",
    name: "Poissy",
    aCity: "à Poissy",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "poissy",
    isPhare: true,
    parentPhareSlug: null,
    nearbyCities: [
      "Carrières-sous-Poissy",
      "Orgeval",
      "Chambourcy",
      "Villennes-sur-Seine",
      "Verneuil-sur-Seine",
      "Vernouillet",
      "Morainvilliers",
    ],
  },
  {
    slug: "carrieres-sous-poissy",
    name: "Carrières-sous-Poissy",
    aCity: "à Carrières-sous-Poissy",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "carrieres-sous-poissy",
    isPhare: false,
    parentPhareSlug: "poissy",
    nearbyCities: [
      "Poissy",
      "Achères",
      "Villennes-sur-Seine",
      "Triel-sur-Seine",
      "Chanteloup-les-Vignes",
    ],
  },
  {
    slug: "orgeval",
    name: "Orgeval",
    aCity: "à Orgeval",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "orgeval",
    isPhare: false,
    parentPhareSlug: "poissy",
    nearbyCities: [
      "Poissy",
      "Morainvilliers",
      "Villennes-sur-Seine",
      "Feucherolles",
      "Chambourcy",
    ],
  },
  {
    slug: "chambourcy",
    name: "Chambourcy",
    aCity: "à Chambourcy",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "chambourcy",
    isPhare: false,
    parentPhareSlug: "poissy",
    nearbyCities: [
      "Poissy",
      "Orgeval",
      "Saint-Germain-en-Laye",
      "Aigremont",
      "L'Étang-la-Ville",
      "Mareil-Marly",
    ],
  },
  {
    slug: "villennes-sur-seine",
    name: "Villennes-sur-Seine",
    aCity: "à Villennes-sur-Seine",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "villennes-sur-seine",
    isPhare: false,
    parentPhareSlug: "poissy",
    nearbyCities: [
      "Poissy",
      "Médan",
      "Vernouillet",
      "Orgeval",
      "Triel-sur-Seine",
      "Morainvilliers",
    ],
  },
  {
    slug: "verneuil-sur-seine",
    name: "Verneuil-sur-Seine",
    aCity: "à Verneuil-sur-Seine",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "verneuil-sur-seine",
    isPhare: false,
    parentPhareSlug: "poissy",
    nearbyCities: [
      "Poissy",
      "Vernouillet",
      "Triel-sur-Seine",
      "Les Mureaux",
      "Médan",
      "Morainvilliers",
    ],
  },
  {
    slug: "vernouillet",
    name: "Vernouillet",
    aCity: "à Vernouillet",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "vernouillet",
    isPhare: false,
    parentPhareSlug: "poissy",
    nearbyCities: [
      "Poissy",
      "Verneuil-sur-Seine",
      "Triel-sur-Seine",
      "Chapet",
      "Médan",
      "Villennes-sur-Seine",
    ],
  },
  {
    slug: "morainvilliers",
    name: "Morainvilliers",
    aCity: "à Morainvilliers",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "morainvilliers",
    isPhare: false,
    parentPhareSlug: "poissy",
    nearbyCities: [
      "Poissy",
      "Orgeval",
      "Villennes-sur-Seine",
      "Médan",
      "Ecquevilly",
      "Vernouillet",
    ],
  },
  {
    slug: "maisons-laffitte",
    name: "Maisons-Laffitte",
    aCity: "à Maisons-Laffitte",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "maisons-laffitte",
    isPhare: true,
    parentPhareSlug: null,
    nearbyCities: [
      "Le Mesnil-le-Roi",
      "Achères",
      "Conflans-Sainte-Honorine",
      "Andrésy",
      "Chanteloup-les-Vignes",
      "Maurecourt",
      "Triel-sur-Seine",
    ],
  },
  {
    slug: "le-mesnil-le-roi",
    name: "Le Mesnil-le-Roi",
    aCity: "au Mesnil-le-Roi",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "le-mesnil-le-roi",
    isPhare: false,
    parentPhareSlug: "maisons-laffitte",
    nearbyCities: [
      "Maisons-Laffitte",
      "Saint-Germain-en-Laye",
      "Sartrouville",
      "Le Pecq",
      "Carrières-sur-Seine",
    ],
  },
  {
    slug: "acheres",
    name: "Achères",
    aCity: "à Achères",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "acheres",
    isPhare: false,
    parentPhareSlug: "maisons-laffitte",
    nearbyCities: [
      "Maisons-Laffitte",
      "Conflans-Sainte-Honorine",
      "Poissy",
      "Andrésy",
      "Saint-Germain-en-Laye",
    ],
  },
  {
    slug: "conflans-sainte-honorine",
    name: "Conflans-Sainte-Honorine",
    aCity: "à Conflans-Sainte-Honorine",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "conflans-sainte-honorine",
    isPhare: false,
    parentPhareSlug: "maisons-laffitte",
    nearbyCities: [
      "Maisons-Laffitte",
      "Maurecourt",
      "Andrésy",
      "Neuville-sur-Oise",
      "Éragny",
      "Achères",
    ],
  },
  {
    slug: "andresy",
    name: "Andrésy",
    aCity: "à Andrésy",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "andresy",
    isPhare: false,
    parentPhareSlug: "maisons-laffitte",
    nearbyCities: [
      "Maisons-Laffitte",
      "Maurecourt",
      "Conflans-Sainte-Honorine",
      "Chanteloup-les-Vignes",
      "Triel-sur-Seine",
      "Achères",
    ],
  },
  {
    slug: "chanteloup-les-vignes",
    name: "Chanteloup-les-Vignes",
    aCity: "à Chanteloup-les-Vignes",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "chanteloup-les-vignes",
    isPhare: false,
    parentPhareSlug: "maisons-laffitte",
    nearbyCities: [
      "Maisons-Laffitte",
      "Andrésy",
      "Triel-sur-Seine",
      "Carrières-sous-Poissy",
      "Maurecourt",
      "Achères",
    ],
  },
  {
    slug: "maurecourt",
    name: "Maurecourt",
    aCity: "à Maurecourt",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "maurecourt",
    isPhare: false,
    parentPhareSlug: "maisons-laffitte",
    nearbyCities: [
      "Maisons-Laffitte",
      "Conflans-Sainte-Honorine",
      "Andrésy",
      "Neuville-sur-Oise",
      "Triel-sur-Seine",
      "Jouy-le-Moutier",
    ],
  },
  {
    slug: "triel-sur-seine",
    name: "Triel-sur-Seine",
    aCity: "à Triel-sur-Seine",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "triel-sur-seine",
    isPhare: false,
    parentPhareSlug: "maisons-laffitte",
    nearbyCities: [
      "Maisons-Laffitte",
      "Vernouillet",
      "Verneuil-sur-Seine",
      "Vaux-sur-Seine",
      "Chanteloup-les-Vignes",
      "Andrésy",
    ],
  },
  {
    slug: "chatou",
    name: "Chatou",
    aCity: "à Chatou",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "chatou",
    isPhare: true,
    parentPhareSlug: null,
    nearbyCities: [
      "Le Vésinet",
      "Croissy-sur-Seine",
      "Bougival",
      "La Celle-Saint-Cloud",
      "Louveciennes",
      "Marly-le-Roi",
      "Le Port-Marly",
    ],
  },
  {
    slug: "le-vesinet",
    name: "Le Vésinet",
    aCity: "au Vésinet",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "le-vesinet",
    isPhare: false,
    parentPhareSlug: "chatou",
    nearbyCities: [
      "Chatou",
      "Croissy-sur-Seine",
      "Saint-Germain-en-Laye",
      "Montesson",
      "Le Pecq",
    ],
  },
  {
    slug: "croissy-sur-seine",
    name: "Croissy-sur-Seine",
    aCity: "à Croissy-sur-Seine",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "croissy-sur-seine",
    isPhare: false,
    parentPhareSlug: "chatou",
    nearbyCities: [
      "Chatou",
      "Le Vésinet",
      "Bougival",
      "Rueil-Malmaison",
      "Louveciennes",
    ],
  },
  {
    slug: "bougival",
    name: "Bougival",
    aCity: "à Bougival",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "bougival",
    isPhare: false,
    parentPhareSlug: "chatou",
    nearbyCities: [
      "Chatou",
      "La Celle-Saint-Cloud",
      "Louveciennes",
      "Croissy-sur-Seine",
      "Rueil-Malmaison",
    ],
  },
  {
    slug: "la-celle-saint-cloud",
    name: "La Celle-Saint-Cloud",
    aCity: "à La Celle-Saint-Cloud",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "la-celle-saint-cloud",
    isPhare: false,
    parentPhareSlug: "chatou",
    nearbyCities: [
      "Chatou",
      "Bougival",
      "Rueil-Malmaison",
      "Le Chesnay-Rocquencourt",
      "Louveciennes",
    ],
  },
  {
    slug: "louveciennes",
    name: "Louveciennes",
    aCity: "à Louveciennes",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "louveciennes",
    isPhare: false,
    parentPhareSlug: "chatou",
    nearbyCities: [
      "Chatou",
      "Marly-le-Roi",
      "La Celle-Saint-Cloud",
      "Bougival",
      "Le Port-Marly",
      "Rocquencourt",
    ],
  },
  {
    slug: "marly-le-roi",
    name: "Marly-le-Roi",
    aCity: "à Marly-le-Roi",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "marly-le-roi",
    isPhare: false,
    parentPhareSlug: "chatou",
    nearbyCities: [
      "Chatou",
      "Louveciennes",
      "Le Pecq",
      "Mareil-Marly",
      "L'Étang-la-Ville",
      "Le Port-Marly",
    ],
  },
  {
    slug: "le-port-marly",
    name: "Le Port-Marly",
    aCity: "au Port-Marly",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "le-port-marly",
    isPhare: false,
    parentPhareSlug: "chatou",
    nearbyCities: [
      "Chatou",
      "Marly-le-Roi",
      "Louveciennes",
      "Le Pecq",
      "Croissy-sur-Seine",
    ],
  },
  {
    slug: "houilles",
    name: "Houilles",
    aCity: "à Houilles",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "houilles",
    isPhare: true,
    parentPhareSlug: null,
    nearbyCities: [
      "Le Vésinet",
      "Croissy-sur-Seine",
      "Bougival",
      "La Celle-Saint-Cloud",
      "Louveciennes",
      "Marly-le-Roi",
      "Le Port-Marly",
    ],
  },
  {
    slug: "carrieres-sur-seine",
    name: "Carrières-sur-Seine",
    aCity: "à Carrières-sur-Seine",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "carrieres-sur-seine",
    isPhare: false,
    parentPhareSlug: "houilles",
    nearbyCities: [
      "Houilles",
      "Chatou",
      "Sartrouville",
      "Montesson",
      "Le Vésinet",
    ],
  },
  {
    slug: "montesson",
    name: "Montesson",
    aCity: "à Montesson",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "montesson",
    isPhare: false,
    parentPhareSlug: "houilles",
    nearbyCities: [
      "Houilles",
      "Chatou",
      "Le Vésinet",
      "Sartrouville",
      "Carrières-sur-Seine",
    ],
  },
  {
    slug: "saint-germain-en-laye",
    name: "Saint-Germain-en-Laye",
    aCity: "à Saint-Germain-en-Laye",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "saint-germain-en-laye",
    isPhare: false,
    parentPhareSlug: "maisons-laffitte",
    nearbyCities: [
      "Maisons-Laffitte",
      "Le Pecq",
      "Mareil-Marly",
      "Fourqueux",
      "Chambourcy",
      "Achères",
    ],
  },
  {
    slug: "le-pecq",
    name: "Le Pecq",
    aCity: "au Pecq",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "le-pecq",
    isPhare: false,
    parentPhareSlug: "maisons-laffitte",
    nearbyCities: [
      "Saint-Germain-en-Laye",
      "Le Mesnil-le-Roi",
      "Montesson",
      "Marly-le-Roi",
      "Le Vésinet",
      "Maisons-Laffitte",
    ],
  },
  {
    slug: "mareil-marly",
    name: "Mareil-Marly",
    aCity: "à Mareil-Marly",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "mareil-marly",
    isPhare: false,
    parentPhareSlug: "maisons-laffitte",
    nearbyCities: [
      "Marly-le-Roi",
      "L'Étang-la-Ville",
      "Saint-Germain-en-Laye",
      "Le Pecq",
      "Louveciennes",
      "Le Port-Marly",
    ],
  },
  {
    slug: "letang-la-ville",
    name: "L'Étang-la-Ville",
    aCity: "à L'Étang-la-Ville",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "letang-la-ville",
    isPhare: false,
    parentPhareSlug: "maisons-laffitte",
    nearbyCities: [
      "Marly-le-Roi",
      "Mareil-Marly",
      "Saint-Nom-la-Bretèche",
      "Noisy-le-Roi",
      "Saint-Germain-en-Laye",
    ],
  },
  {
    slug: "feucherolles",
    name: "Feucherolles",
    aCity: "à Feucherolles",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "feucherolles",
    isPhare: false,
    parentPhareSlug: "plaisir",
    nearbyCities: [
      "Saint-Nom-la-Bretèche",
      "Chavenay",
      "Davron",
      "Crespières",
      "Noisy-le-Roi",
      "Villepreux",
    ],
  },
  {
    slug: "sartrouville",
    name: "Sartrouville",
    aCity: "à Sartrouville",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "sartrouville",
    isPhare: true,
    parentPhareSlug: null,
    nearbyCities: [
      "Houilles",
      "Maisons-Laffitte",
      "Le Mesnil-le-Roi",
      "Montesson",
      "Carrières-sur-Seine",
      "Bezons",
      "Aigremont",
      "Andelu",
      "Bazemont",
      "Crespières",
      "Herbeville",
      "Les Alluets-le-Roi",
      "Mareil-sur-Mauldre",
    ],
  },
  {
    slug: "aigremont",
    name: "Aigremont",
    aCity: "à Aigremont",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "aigremont",
    isPhare: false,
    parentPhareSlug: "sartrouville",
    nearbyCities: [
      "Poissy",
      "Chambourcy",
      "Saint-Germain-en-Laye",
      "Feucherolles",
      "Sartrouville",
    ],
  },
  {
    slug: "andelu",
    name: "Andelu",
    aCity: "à Andelu",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "andelu",
    isPhare: false,
    parentPhareSlug: "sartrouville",
    nearbyCities: [
      "Maule",
      "Thoiry",
      "Bazemont",
      "Mareil-sur-Mauldre",
      "Sartrouville",
    ],
  },
  {
    slug: "bazemont",
    name: "Bazemont",
    aCity: "à Bazemont",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "bazemont",
    isPhare: false,
    parentPhareSlug: "sartrouville",
    nearbyCities: [
      "Herbeville",
      "Aulnay-sur-Mauldre",
      "Maule",
      "Flins-sur-Seine",
      "Andelu",
      "Sartrouville",
    ],
  },
  {
    slug: "crespieres",
    name: "Crespières",
    aCity: "à Crespières",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "crespieres",
    isPhare: false,
    parentPhareSlug: "sartrouville",
    nearbyCities: [
      "Feucherolles",
      "Les Alluets-le-Roi",
      "Mareil-sur-Mauldre",
      "Thoiry",
      "Herbeville",
      "Sartrouville",
    ],
  },
  {
    slug: "herbeville",
    name: "Herbeville",
    aCity: "à Herbeville",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "herbeville",
    isPhare: false,
    parentPhareSlug: "sartrouville",
    nearbyCities: [
      "Mareil-sur-Mauldre",
      "Maule",
      "Crespières",
      "Les Alluets-le-Roi",
      "Bazemont",
      "Sartrouville",
    ],
  },
  {
    slug: "les-alluets-le-roi",
    name: "Les Alluets-le-Roi",
    aCity: "aux Alluets-le-Roi",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "les-alluets-le-roi",
    isPhare: false,
    parentPhareSlug: "sartrouville",
    nearbyCities: [
      "Orgeval",
      "Crespières",
      "Maule",
      "Morainvilliers",
      "Ecquevilly",
      "Sartrouville",
    ],
  },
  {
    slug: "mareil-sur-mauldre",
    name: "Mareil-sur-Mauldre",
    aCity: "à Mareil-sur-Mauldre",
    deptCode: "78",
    deptSlug: "yvelines",
    deptName: "Yvelines",
    deptNameWithArticle: "des Yvelines",
    templateId: "mareil-sur-mauldre",
    isPhare: false,
    parentPhareSlug: "sartrouville",
    nearbyCities: [
      "Maule",
      "Beynes",
      "Montainville",
      "Herbeville",
      "Crespières",
      "Bazemont",
      "Sartrouville",
    ],
  },
];

export const getYvelinesCityPageBySlug = (slug) =>
  YVELINES_CITY_PAGES.find((c) => c.slug === slug) || null;

export default YVELINES_CITY_PAGES;
